export default {"src":"/_next/static/media/success-icon.44c9bece.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};